import React from "react"
import useStyles from "./dropZoneStyles"
import { Box, IconButton } from "@material-ui/core"
import DeleteIcon from "@material-ui/icons/Delete"

const RenderFileList = ({ files, handleDelete, isDelete = false }) => {
	const classes = useStyles()

	function formatFileSize(bytes) {
		if (bytes === 0) return "0 Bytes"
		const k = 1024
		const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + "" + sizes[i]
	}

	return (
		<ul className={classes.listWrapper}>
			{files.map((file, fid) => (
				<li className={classes.listItem}>
					<Box key={fid} display="flex" alignItems="center" justifyContent="space-between">
						<div style={{ display: "flex", maxWidth: "100%" }}>
							<p title={file.name} className={classes.fileName}>
								{file.name} -{" "}
							</p>
							<p className={classes.fileSize}>{formatFileSize(file.size)}</p>
						</div>
						{isDelete && (
							<IconButton
								onClick={() => handleDelete(file.name)}
								aria-label="delete"
								color="primary"
								style={{ backgroundColor: "transparent" }}
								title="Delete"
							>
								<DeleteIcon fontSize="small" color="disabled" />
							</IconButton>
						)}
					</Box>
				</li>
			))}
		</ul>
	)
}

export default RenderFileList
